export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11460.f7f97084.jpg";